import { cn } from '@/lib/cn';

/** "Chileleko Ng'andu" -> "CN". One word gives one letter. */
export const initialsOf = (fullName: string): string => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]![0]!;
  const last = parts.length > 1 ? parts[parts.length - 1]![0]! : '';
  return (first + last).toUpperCase();
};

const SIZES = { sm: 'h-7 w-7 text-micro', md: 'h-9 w-9 text-label', lg: 'h-16 w-16 text-section' };

/** A circle with a person's initials. Decorative: the name is always written next to it. */
export const Avatar = ({ name, size = 'md', className }: { name: string; size?: keyof typeof SIZES; className?: string }) => (
  <span
    aria-hidden
    className={cn(
      'inline-flex shrink-0 items-center justify-center rounded-full bg-brand-tint font-semibold text-brand-ink',
      SIZES[size],
      className
    )}
  >
    {initialsOf(name)}
  </span>
);
